import { Container, Form, Button, Row, Col } from "react-bootstrap";
import Navbar from "./Navbar.js";
import { useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Api from "../Api/Api";
import { username } from "../API.js";
import React from "react";
const Search = () => {
  // const { username } = useParams();
  const [searchElement, setSearchElement] = useState([]);
  const [search, setSearch] = useState("");
  const searchHandler = async (e) => {
    e.preventDefault();
    const { data } = await Api.getSearchItems(search);
    setSearchElement(data);
  };
  return (
    <>
      <Navbar />
      <Container>
        <div className="d-inline-flex flex-wrap w-100 justify-content-center align-items-center mt-5">
          <Container
            className="bg-light rounded mt-5"
            style={{ height: "88vh" }}
          >
            <Form>
              <Container>
                <Row className="mt-4">
                  <Col md={{ span: 6, offset: 3 }}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Search</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Chhota Bheem"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <Form.Text className="text-muted">
                        Min Three Characters
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={{ span: 2, offset: 6 }}>
                    <Button
                      variant="primary"
                      type="submit"
                      className="mt-3 btn-primary btn-block"
                      disabled={search.length < 3}
                      onClick={(e) => searchHandler(e)}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
            <div className="overflow-scroll" style={{ height: "73.9%" }}>
              {searchElement.length !== 0 &&
                searchElement.map((movie, index) => {
                  return (
                    <Row key={index}>
                      {console.log(movie)}
                      <Col md={{ span: 8, offset: 3 }}>
                        <Link
                          to={
                            movie.season
                              ? `/${username}/tvshowview/${movie._id}`
                              : `/${username}/view/${movie._id}`
                          }
                          className="text-decoration-none text-dark"
                        >
                          <div class="card mt-3" style={{ maxWidth: "700px" }}>
                            <div class="row g-0">
                              <div class="col-md-4">
                                <img
                                  src={movie.thumbnail}
                                  className="img-fluid rounded-start rounded m-1"
                                  alt={movie.title}
                                  style={{ width: "100%" }}
                                />
                              </div>
                              <div class="col-md-8">
                                <div class="card-body">
                                  <div className="d-inline-flex flex-wrap w-100 justify-content-between">
                                    <h5 class="card-title">{movie.title}</h5>
                                    <p className="text-dark">
                                      {!movie.season ? "Movie" : "Tv Show"}{" "}
                                      {movie.Ratings?.imDb}
                                    </p>
                                  </div>
                                  <p class="card-text">
                                    {movie.season
                                      ? movie.Languages
                                      : movie.Plot}
                                  </p>
                                  <p class="card-text">
                                    <small class="text-muted">
                                      Release Date{" "}
                                      {!movie.season?.length
                                        ? `${
                                            new Date(
                                              movie.launchDate
                                            ).getDate() + 1
                                          }-${
                                            new Date(
                                              movie.launchDate
                                            ).getMonth() + 1
                                          }-${new Date(
                                            movie.launchDate
                                          ).getFullYear()}`
                                        : `${
                                            new Date(movie.date).getDate() + 1
                                          }-${
                                            new Date(movie.date).getMonth() + 1
                                          }-${new Date(
                                            movie.date
                                          ).getFullYear()}`}
                                    </small>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </Col>
                    </Row>
                  );
                })}
            </div>
          </Container>
        </div>
      </Container>
    </>
  );
};
export default Search;
